import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { ModuleModel } from "models/locker/entities/ModuleModel";
import { OrganizationSimpleModel } from "models/company/entities/OrganizationSimpleModel";

export interface ILockerModel extends IGenericBaseModel {
    uuid: string;
    name: string
    containersCount: number
    hoursToReverse: number
    organization: OrganizationSimpleModel
}


export class LockerModel implements ILockerModel {
    uuid: string;
    name: string
    containersCount: number
    hoursToReverse: number
    organization: OrganizationSimpleModel

    constructor(data: ILockerModel) {
        this.uuid = data.uuid;
        this.name = data.name;
        this.containersCount = data.containersCount;
        this.hoursToReverse = data.hoursToReverse;
        this.organization = new OrganizationSimpleModel(data.organization);
    }
}